<template>
  <v-container class="pa-0" fluid>
    <v-row justify="center">
      <v-col cols="12">
        <!-- Header -->
        <v-row align="center" justify="center">
          <v-col cols="12" md="auto" class="mt-0 pt-0">
            <div class="d-flex align-center justify-center">
              <v-avatar color="primary" size="52" class="mr-3 elevation-2">
                <v-icon color="white" size="28">request_quote</v-icon>
              </v-avatar>
              <div>
                <div class="text-h5 font-weight-bold grey--text text--darken-2">Cotizaciones</div>
                <div class="text-caption grey--text">Consulta y gestiona las cotizaciones</div>
              </div>
            </div>
          </v-col>
        </v-row>

        <!-- Filters -->
        <v-row justify="center">
          <v-col cols="12">
            <search-header-po @dataFilters="changeBusiness($event)" />
          </v-col>
        </v-row>
        <v-card v-if="!loadingSave" class="rounded-lg mt-3">
          <v-expand-transition>
            <v-row v-if="loading" justify="center">
              <v-col cols="12" md="10">
                <v-skeleton-loader
                  type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
                >
                </v-skeleton-loader>
              </v-col>
            </v-row>
            <v-data-table
              v-else
              height="54vh"
              :search="search"
              :headers="headers"
              :items-per-page="15"
              :items="filteredInvoices"
              class="elevation-0"
              dense
              hide-default-footer
              @page-count="pageCount = $event"
              :page.sync="page"
            >
              <template v-slot:top>
                <v-toolbar class="elevation-0 rounded-lg">
                  <v-toolbar-title>Cotizaciones</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-text-field
                    label="Buscar..."
                    class="mt-6"
                    outlined
                    dense
                    v-model="search"
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-btn v-if="hasFeature('ING-012')" @click="showNew" color="primary" dark outlined class="mb-2">
                    <v-icon small>add</v-icon>
                    Nueva cotización
                  </v-btn>
                  <v-dialog transition="slide-x-transition" v-model="dialog" fullscreen>
                    <v-card style="background-color: #f4f5fa">
                      <v-container>
                        <v-row class="mt-4" justify="end"> </v-row>
                        <v-row justify="center">
                          <v-col v-if="dialog" cols="12" md="12" lg="12" xl="12">
                            <invoice
                              :type="type_quote"
                              :editOrCopy="editedItem"
                              :itbis="itbis"
                              :credit_days="credit_days"
                              :ncfTypes="ncfTypes"
                              :withholdings="withholdings"
                              :boxes="boxes"
                              :accounts="accounts"
                              :itemsLocations="itemsLocations"
                              :invoice_categories="invoice_categories"
                              :itemsDepartments="itemsDepartments"
                              :editOrCopyStatus="editOrCopyStatus"
                              :quotation_id="quotation_id"
                              @close-dialog="clear()"
                              @save-invoice="save($event)"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-card-text>
                        <v-row> </v-row>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                      <v-card-title class="text-h5"
                        >Are you sure you want to delete this item?</v-card-title
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDelete"
                          >Cancel</v-btn
                        >
                        <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                          >OK</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:[`item.invoice_number`]="{ item }">
                <v-hover v-slot="{ hover }">
                  <span
                    @click="showInvoice(item.invoice_id, true)"
                    class="primary--text font-weight-normal text-truncate font-weight-semibold"
                    :style="{
                      color: hover ? 'red' : 'black',
                      cursor: hover ? 'pointer' : '',
                      'text-decoration': hover ? 'underline' : '',
                    }"
                  >
                    <span v-if="item.invoice_type_id == 5">
                      {{ item.invoice_type_name }} -</span
                    >
                    {{ item.invoice_number }}</span
                  >
                </v-hover>
              </template>
              <template v-slot:[`item.has_quotation`]="{ item }">
                <v-hover v-slot="{ hover }">
                  <span
                    @click="showInvoice(item.new_invoice_id, true)"
                    v-if="item.new_invoice_id != null"
                    class="primary--text font-weight-normal text-truncate font-weight-semibold"
                    :style="{
                      color: hover ? 'red' : 'black',
                      cursor: hover ? 'pointer' : '',
                      'text-decoration': hover ? 'underline' : '',
                    }"
                  >
                    <span class="red--text d-flex" v-if="item.invoice_type_id == 5">
                    </span>

                    {{ item.has_quotation }}
                  </span>
                  <span v-else>{{ item.has_quotation }}</span>
                </v-hover>
                <br />
              </template>
              <template v-slot:[`item.total_amount`]="{ item }">
                <span>
                  {{ currencyFormat(item.total_amount) }}
                  {{ item.currency_code }}</span
                >
              </template>

              <template v-slot:[`item.entity_name`]="{ item }">
                <v-hover v-slot="{ hover }">
                  <span
                    @click="viewEntity(item.entity_id)"
                    style="font-size: 14px"
                    class="primary--text font-weight-normal text-truncate font-weight-semibold"
                    :style="{
                      color: hover ? 'red' : 'black',
                      cursor: hover ? 'pointer' : '',
                      'text-decoration': hover ? 'underline' : '',
                    }"
                    >{{ item.entity_name }}</span
                  ></v-hover
                >
              </template>
              <template v-slot:[`item.recorded`]="{ item }">
                <v-chip small color="success" v-if="item.recorded">
                  <span>Contabilizada </span>
                </v-chip>
                <v-chip
                  small
                  :color="item.invoice_type_id != 5 ? 'warning' : 'grey lighten-1'"
                  v-else
                >
                  <span class="text--primary">{{
                    item.invoice_type_id == 5 ? "No contabilizable" : "Sin contabilizar"
                  }}</span>
                </v-chip>
              </template>
              <template v-slot:[`item.status_id`]="{ item }">
                <v-chip small outlined color="success" v-if="item.status_id == 1">
                  Activa
                </v-chip>
                <v-chip small outlined color="red" v-else> Anulada </v-chip>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      @click="toInvoice(item, true)"
                      v-show="item.new_invoice_id == null && item.status_id == 1 && hasFeature('ING-012')"
                      v-bind="attrs"
                      v-on="on"
                      color="primary"
                      large
                    >
                      read_more
                    </v-icon>
                  </template>
                  <span>Convertir en factura</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-show="item.new_invoice_id == null && item.status_id == 1 && hasFeature('ING-012')"
                      v-bind="attrs"
                      v-on="on"
                      medium
                      color="warning"
                      class="mx-1"
                      @click="editItem(item, false)"
                      >edit</v-icon
                    >
                  </template>
                  <span>Editar</span>
                </v-tooltip>
              </template>
              <template v-slot:no-data>
                <v-row justify="center" class="pt-10">
                  <v-icon size="80px">token</v-icon>
                </v-row>
                <v-row justify="center" class="pb-6"> No hay datos </v-row>
              </template>
              <template slot="footer">
                <v-row justify="center">
                  <v-container style="width: 70%" class="mt-4">
                    <v-pagination v-model="page" :length="pageCount"></v-pagination>
                  </v-container>
                </v-row>
              </template>
            </v-data-table>
          </v-expand-transition>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  data: () => ({
    loadingSave: false,
    editOrCopyStatus: false,
    page: 1,
    pageCount: 0,
    search: "",
    loading: false,
    viewVouchers: false,

    dialog: false,
    dialogDelete: false,
    suplidor: false,
    cliente: false,
    disabledName: false,
    plazoPagoSuplidor: null,
    plazoPagoCliente: null,
    documents: [],
    rncValid: false,
    ncfTypes: [],
    accounts: [],
    provincies: [],
    invoices: [],
    itemsLocations: [],
    itemsDepartments: [],
    cxc: "",
    cxp: "",
    itbis: [],
    credit_days: [],

    invoice_categories: [],
    withholdings: [],
    boxes: [],
    quotation_id: null,
    selectedDocument: "",
    selectedtypesNcfCliente: "",
    selectedtypesNcfSuplidor: "",
    selectedProvincies: "",
    headers: [
      {
        text: "Cotizacion",
        align: "start",
        value: "invoice_number",
      },
      {
        text: "Factura",
        value: "has_quotation",
      },
      {
        text: "Unidad negocio",
        value: "business_unit_description",
      },
      { text: "Fecha", value: "emission_date" },
      { text: "Cliente", value: "entity_name" },
      { text: "Sucursal", value: "branche" },
      // { text: "Contabilidad", value: "recorded" },
      { text: "Total", value: "total_amount", align: "end" },
      { text: "Status", value: "status_id" },
      { text: "Actions", value: "actions" },

      //{ text: "Actions", value: "actions", sortable: false },
    ],
    lastFilters: {},
    editedIndex: -1,
    editedItem: {},
    type_quote: 6,
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo contacto" : "Editar contacto";
    },
    filteredInvoices() {
      const data = this.invoices.filter((invoice) => {
        // Filtrar solo las facturas con invoice_type_id igual a 5
        if (invoice.invoice_type_id === 5) {
          // Verificar si viewVouchers es true
          if (this.viewVouchers) {
            return true; // Devolver la factura si viewVouchers es true
          } else {
            return false; // No devolver la factura si viewVouchers es false
          }
        } else {
          return invoice;
        }
      });

      return data;
    },
  },
  watch: {},
  created() {
    this.init();
  },
  methods: {
    async init() {
      const result = await Promise.all([
        this.api_Get("accounting/taxes"),
        this.api_Get("accounting/accountsUsable"),
        this.api_Get("humanResource/locations"),
        this.api_Get("income/boxes"),
        this.api_Get("accounting/withholdings"),
        this.api_Get("income/invoice_categories"),
        this.api_Get("accounting/nfc_types"),
        this.api_Get("accounting/credit_days"),
        this.g_departments(),
      ]);

      this.itbis = await result[0].json();

      for (let item of await result[1].json()) {
        this.accounts.push({
          text: item.code + " - " + item.name,
          value: item.id,
          id: item.id,
          dgii_category_id: item.dgii_category_id,
        });
      }
      for (let item of await result[2].json()) {
        for (let item2 of this.$store.state.auth.locations) {
          if (item2.id == item.id) {
            this.itemsLocations.push({
              value: item.id,
              text: item.desc_loc_long,
              id: item.id,
              bus_id: item.bus_id,
              desc_bus_short: item.desc_bus_short,
              desc_bus_long: item.desc_bus_long,
              desc_loc_short: item.desc_loc_short,
              desc_loc_long: item.desc_loc_long,
              city_id: item.city_id,
              city_description: item.city_description,
              location_adress: item.location_adress,
              status_id: item.status_id,
              catalogue_id: item.catalogue_id,
              catalogue_name: item.catalogue_name,
              rnl: item.rnl,
              representative_name: item.representative_name,
              sta_description: item.sta_description,
              employee_representative_id: item.employee_representative_id,
            });
          }
        }
      }
      this.boxes = await result[3].json();
      this.withholdings = await result[4].json();
      this.invoice_categories = await result[5].json();
      this.ncfTypes = await result[6].json();
      this.ncfTypes.unshift({ id: 0, name: "SIN COMPROBANTE" });
      this.credit_days = await result[7].json();
      this.itemsDepartments = await result[8];
    },
    async getData(data) {
      this.loading = true;
      let filters = "";
      filters += "WHERE INVOICE_TYPE_ID in(6 )";
      filters +=
        data.business == null
          ? " "
          : " AND   INVOICES.BUSINESS_UNIT_ID in (" + data.business + ") ";
      filters +=
        data.location == null || data.location == 0
          ? ""
          : " AND INVOICES.LOCATION_ID IN (" + data.location + ")";
      filters +=
        data.department_id == null || data.department_id == 0
          ? ""
          : " AND DEPARTMENT_ID =" + data.department_id + "";
      filters +=
        " AND INVOICES.EMISSION_DATE::DATE BETWEEN '" +
        data.dateStart +
        "' and '" +
        data.dateEnd +
        "' ";
      let resultInvoices = await this.api_Post("income/quote_sales_list", {
        filters: filters,
      });

      this.invoices = await resultInvoices.json();
      for (let key in this.invoices) {
        this.invoices[key].emission_date = moment(
          this.invoices[key].emission_date
        ).format("DD/MM/YYYY");
      }
      this.loading = false;
    },

    changeBusiness(data) {
      this.lastFilters = data;
      if (data.business == 0) {
        this.getData({
          business: this.$store.state.auth.user.acess_business_unit_finance,
          location: null,
          dateStart: data.dateStart,
          dateEnd: data.dateEnd,
        });
      } else {
        this.getData(data);
      }
    },
    clear() {
      this.editedItem = null;
      this.dialog = false;
    },
    showNew() {
      this.quotation_id = null;
      this.editedItem = {};
      this.editOrCopyStatus = false;
      this.dialog = true;
    },
    async editItem(item, type) {
      this.editOrCopyStatus = true;
      this.quotation_id = null;
      const responseRequest = await this.api_Post("income/search_invoice_id", {
        number: item.invoice_id,
      });

      if (responseRequest.status == 200) {
        let invoice = await responseRequest.json();

        this.editedItem = Object.assign({}, invoice[0]);
        this.editedItem.is_editing = true;

        let data = this.editedItem;
        if (type === true) {
          data.invoice_id = 0;
        }
      }
      this.type_quote = 6;
      this.dialog = true;
    },
    async toInvoice(data, type) {
      this.editOrCopyStatus = true;
      this.quotation_id = null;
      const responseRequest = await this.api_Post("income/search_invoice_id", {
        number: data.invoice_id,
      });

      let invoice = await responseRequest.json();

      this.editedItem = Object.assign({}, invoice[0]);

      this.editedItem.invoice_type_id = 10;
      this.type_quote = 10;
      this.quotation_id = data.invoice_id;

      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.entitys.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.entitys.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;

      this.$nextTick(() => {
        this.editedItem = [];
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save(data) {
      this.loadingSave = true;

      this.getData(this.lastFilters);

      this.showInvoice(data[0].id, true);
      this.dialog = false;

      this.loadingSave = false;
    },
  },
};
</script>

<style></style>
